var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZnnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 45,
    viewBox: "0 0 28 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V5.51779H18.0102L0 16.7249V45H4.88073V30.9053L23.0336 45H28V17.4968H9.19063L28 5.43202V0ZM23.0336 22.9574V37.6525L4.88073 22.9574H23.0336Z",
    fill: "url(#paint0_linear_3_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_23",
    x1: 13.9857,
    y1: 0,
    x2: 13.9857,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FF34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BD926",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZnnLogo);
export default __webpack_public_path__ + "static/media/znn-logo.6f00ef852a5bbbb9f18752f94751f67e.svg";
export { ForwardRef as ReactComponent };